var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RenderBlock } from '../../render-layout.models';
/**
 * Lobby lotteries grid - template-1 variant: a plain list of every lottery (logo/details/jackpot/
 * next-draw/play), with no quick-play and no show-more paging (those are template-7's grid).
 * Lottery data lives on the shell (host).
 */
var LotteriesGridT1 = /** @class */ (function (_super) {
    __extends(LotteriesGridT1, _super);
    function LotteriesGridT1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LotteriesGridT1;
}(RenderBlock));
export { LotteriesGridT1 };
